import Services from "../components/services";
import { useNavigate } from "react-router-dom";

export default function ServicesModal() {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-md flex items-center justify-center p-4">
      <div
        className="
          relative
          w-full
          max-w-6xl
          max-h-[90vh]
          overflow-y-auto
          rounded-[32px]
          shadow-[0_25px_80px_rgba(0,0,0,0.25)]
        "
        style={{
          background:
            "linear-gradient(135deg, #FFFDF9 0%, #F8F3ED 50%, #EADCC8 100%)",
        }}
      >
        {/* Gold Glow */}
        <div
          className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl opacity-20 pointer-events-none"
          style={{
            background: "#D4AF37",
          }}
        />

        {/* Soft Cream Glow */}
        <div
          className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full blur-3xl opacity-10 pointer-events-none"
          style={{
            background: "#EADCC8",
          }}
        />

        {/* Close Button */}
        <button
          onClick={() => navigate(-1)}
          className="
            absolute
            top-6
            right-6
            z-50
            flex
            items-center
            justify-center
            w-12
            h-12
            rounded-full
            bg-white/70
            backdrop-blur-sm
            text-[#2A2A2A]
            text-2xl
            font-bold
            transition-all
            duration-300
            hover:bg-[#D4AF37]
            hover:text-white
            hover:scale-110
          "
        >
          ×
        </button>

        {/* Content */}
        <div className="relative z-10">
          <Services />
        </div>
      </div>
    </div>
  );
}
